import {useCallback} from 'react';
import {useShallow} from 'zustand/react/shallow';

import {useItemAccessibleNames} from '../../shared/accessibleName';
import {useQuestionTranslationStore} from '../../shared/TranslationSection/TranslationStore';
import {orderingGapText} from '../../shared/TranslationSection/TranslationText';
import type {OrderingItem} from '../store';
import {englishGapCopy, insertPointLabel} from './announcements';

/**
 * Gives the spoken name of the gap at a divider index, in the language the question is shown in.
 * One name for the gap's button and for what is announced as an item moves over it.
 */
export const useInsertPointLabel = (items: OrderingItem[]): ((dividerIndex: number) => string) => {
  const {showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );
  const itemNames = useItemAccessibleNames(items.map((item) => item.value));
  const gapCopy = showTranslations ? orderingGapText : englishGapCopy;

  return useCallback(
    (dividerIndex: number) => insertPointLabel(itemNames, dividerIndex, gapCopy),
    [itemNames, gapCopy]
  );
};
